import { render, staticRenderFns } from "./ReferencesTree.vue?vue&type=template&id=bc492702&scoped=true&"
import script from "./ReferencesTree.vue?vue&type=script&lang=ts&"
export * from "./ReferencesTree.vue?vue&type=script&lang=ts&"
import style0 from "./ReferencesTree.vue?vue&type=style&index=0&id=bc492702&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc492702",
  null
  
)

export default component.exports